<template>
  <div class="main-container">
    <div class="search-box btn3" :class="{ 'close': !searchMore }">
      <div class="input-item select-two">
        <Select v-model="searchParams.dateType" :transfer="true">
          <Option value="1">投保日期</Option>
          <Option value="2">支付日期</Option>
          <Option value="3">起保日期</Option>
        </Select>
        <DatePicker
          v-model="searchParams.date"
          type="daterange"
          split-panels
          separator=" 至 "
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
          <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">订单号</span>
        <Input v-model="searchParams.orderNo" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">订单状态</span>
        <Select v-model="searchParams.checkInsuranceStatusList" multiple :transfer="true" clearable>
          <Option value="0">待投保</Option>
          <Option value="5">核保中</Option>
          <Option value="-5">核保失败</Option>
          <Option value="1">待支付</Option>
          <Option value="2">待实收</Option>
          <Option value="3">待承保</Option>
          <Option value="4">已完成</Option>
          <Option value="-2">承保失败</Option>
          <Option value="99">已退款</Option>
          <Option value="-9">已失效</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">投保人名称</span>
        <Input v-model="searchParams.holderName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">投保人证件号</span>
        <Input v-model="searchParams.cardNo" placeholder="请输入" clearable />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
          >收起
          <Icon type="ios-arrow-up" />
        </Button>
        <Button type="primary" ghost v-else @click="searchMore = true"
          >展开
          <Icon type="ios-arrow-down" />
        </Button>
      </div>
    </div>
    <div class="tools-box">
      <Button type="warning" @click="exportToExcel">导出</Button>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detail(row)">详情</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { pageTool } from '@/api/mixins';
import { mapState } from 'vuex';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, config],
  components: {},
  data() {
    return {
      loading: false,
      companyList: []
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    this.tableData = [];
    this.getColumns();
    this.getCompanyList();
    this.initListParams('/buz/grouporder/read/list');
  },
  activated() {
    if (sessionStorage.queryOrderNo) {
      this.searchParams.orderNo = sessionStorage.queryOrderNo;
      sessionStorage.removeItem('queryOrderNo');
    }
    this.getList();
  },
  methods: {
    // 导出
    exportToExcel() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.$http({
        url: '/buz/grouporder/export',
        type: 'POST',
        responseType: 'blob',
        data: params
      })
        .then(res => {
          this.loading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.loading = false;
        });
    },
    detail(row) {
      if (row.type == 1 || row.dockChannel == 3) {
        this.$http({
          url: `/buz/grouporder/detail?orderNo=${row.orderNo}`,
          type: 'GET'
        }).then(res => {
          window.open(res.data, '_blank');
        });
      } else {
        // 手动录入
        this.$router.push({
          path: '/orderManage/group/order/detail',
          query: {
            id: row.id || '',
            policyNo: row.policyNo,
            orderNo: row.orderNo,
            payType: row.payType,
            productCategory: row.productCategory, //1-团险 2-财产险 3、个险
            status: row.status //保单状态 1-保障中 -1-退保 0-终止
          }
        });
      }
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 转化参数
    setListParams(params) {
      delete params.applyOrgId;
      if (params.date && params.date[0]) {
        let date1 = dayjs(params.date[0]).format('YYYY-MM-DD');
        let date2 = dayjs(params.date[1]).format('YYYY-MM-DD');
        if (params.dateType == 1) {
          //投保日期
          params.createTimeStart = date1;
          params.createTimeEnd = date2;
        } else if (params.dateType == 2) {
          //支付日期
          params.payTimeStart = date1;
          params.payTimeEnd = date2;
        } else if (params.dateType == 3) {
          //起保日期
          params.startTimeStart = date1;
          params.startTimeEnd = date2;
        }
      }
      if (params.checkInsuranceStatusList && params.checkInsuranceStatusList.includes('99')) {
        params.status = 3;
      } else {
        delete params.status;
      }
      delete params.dateType;
      delete params.date;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  padding-right: 250px;
}

.tools-box {
  display: flex;
  justify-content: flex-end;
}
</style>
